import { Text } from "@chakra-ui/react"
import { Bounce, toast, ToastOptions, TypeOptions } from "react-toastify"

const toastOptions: ToastOptions = {
  position: "bottom-right",
  autoClose: 2000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  transition: Bounce,
  closeButton: true,
}

export const notify = (text: string, type: TypeOptions, options?: ToastOptions) => {
  // Функция, а не готовый элемент: элементу toastify подкладывает свои пропсы
  // (closeToast, toastProps), Text отдавал их в DOM — предупреждения в консоли
  const content = () => (
    <Text fontSize="md" fontWeight="medium">
      {text}
    </Text>
  )

  toast(content, { ...toastOptions, ...options, type })
}
